import { gql } from '@/__generated__';
import { useQueryTypeahead } from '@/components/use-query-typeahead';

const StreamDeckTypeaheadStreamsQuery = gql(`
  query StreamDeckTypeaheadStreamsQuery($query: String!, $limit: Int = 10, $offset: Int = 0, $followingFirst: Boolean = true, $paidFirst: Boolean = true) {
  streamsTypeaheadQuery: typeahead(input: {text: $query, limit: $limit, offset: $offset, type: [Stream], followingFirst: $followingFirst, paidFirst: $paidFirst}) {
      streams {
        id
        ...StreamCardFragment
        canAddToStreamDeck
        accessAllowed
        following
        customTargetsData {
          ...CustomTargetsDataFragment
        }
      }
      offset
    }
  }
  `);

export const useTypeaheadStreams = () => {
  const { data, ...rest } = useQueryTypeahead(StreamDeckTypeaheadStreamsQuery);
  return {
    streams: data?.streamsTypeaheadQuery.streams,
    ...rest,
  };
};
